import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const NetworksRoutes: Routes = [
  {
    path: "networks",
    loadComponent: () =>
      import("./networks/networks.component").then((m) => m.NetworksComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./networks-list/networks-list.component").then(
            (m) => m.NetworksListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./networks-form/networks-form.component").then(
            (m) => m.NetworksFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./networks-form/networks-form.component").then(
            (m) => m.NetworksFormComponent,
          ),
      },
    ],
  },
];
